import { axiosInstance } from "../config/axios";

const endpoint = "group/";

export const Create = async (params) => {
	try {
		const res = await axiosInstance.post(endpoint, params);
		const { data } = res;
		return {
			success: data.success,
			...(typeof data.data === "object" && data.data !== null
				? data.data
				: {}),
		};
	} catch (error) {
		const message =
			error.response?.data?.error ||
			error.response?.data?.detail ||
			error.message ||
			"Something went wrong";

		return {
			success: false,
			error: message,
		};
	}
};

export const getAllSeller = async () => {
	try {
		const res = await axiosInstance.get(endpoint);

		const { data } = res;
		data["success"] = true;
		return res.data;
	} catch (e) {
		const data = {
			success: false,
		};
		return data;
	}
};

export const getStylistUsers = async () => {
	try {
		const res = await axiosInstance.get("stylist/");

		const { data } = res;
		data["success"] = true;
		return res.data;
	} catch (error) {
		const message =
			error.response?.data?.error ||
			error.response?.data?.detail ||
			error.message ||
			"Something went wrong";

		return {
			success: false,
			error: message,
		};
	}
};

export const UpdateGroup = async (params, id) => {
	try {
		const res = await axiosInstance.put(`${endpoint}${id}/`, params);
		const { data } = res;

		return {
			success: data.success,
			...(typeof data.data === "object" && data.data !== null
				? data.data
				: {}),
		};
	} catch (e) {
		const data = {
			success: false,
		};
		return data;
	}
};
